import React from 'react';
import { useGeneralStore } from 'src/store';
import { Link, useLocation } from 'react-router-dom';

export const ProfileFooter = () => {
  const { siteConfig } = useGeneralStore();
  const location = useLocation();
  const isHealthhub = location.pathname === '/healthhub';

  const logoSrc = isHealthhub
    ? siteConfig?.images?.emailFooter
    : siteConfig?.images?.emailFooter || '/icons/new-logo1.svg';
  const isLolly = document.body.classList.contains('skin-lolly');
  const primaryColor = isLolly
    ? '#323232'
    : getComputedStyle(document.documentElement)
        .getPropertyValue('--color-primary')
        .trim();

  // const socialLinks = [
  //   { icon: '/icons/facebook.svg', alt: 'facebook' },
  //   { icon: '/icons/twitter.svg', alt: 'twitter' },
  //   { icon: '/icons/linkedin.svg', alt: 'linkedin' },
  // ];

  return (
    <footer
      style={{ backgroundColor: primaryColor }}
      className="pb-12 px-12 pr-19 flex flex-col rounded-3xl max-sm:px-8"
    >
      <Link to="/form">
        <img
          src={logoSrc}
          alt="onehealth-logo"
          className="w-70 max-md:w-50 h-auto my-8"
        />
      </Link>
      <div className="flex justify-between max-sm:flex-col max-sm:gap-8">
        <div className="flex justify-between w-[29%] max-l:w-[40%] max-md:w-[60%] max-sm:w-[70%] max-2xs:w-[85%]">
          {/* <nav className="flex flex-col text-white font-bold gap-4 max-l:gap-2">
            <a className="text-[10px] tracking-wider" href="#">
              ABOUT US
            </a>
            <a className="text-[10px] tracking-wider" href="#">
              PRIVACY PROMISE
            </a>
            <a className="text-[10px] tracking-wider" href="#">
              TERMS OF SERVICE
            </a>
          </nav> */}
          <section className="text-white">
            <h3 className="text-xs">HAVE QUESTIONS?</h3>
            <p className="flex flex-col mt-2">
              <span className="text-[10px]">email our support staff at </span>
              <a
                className="text-[10px]"
                href={`mailto:${siteConfig?.emails?.secondary || ''}`}
              >
                {siteConfig?.emails?.secondary || ''}
              </a>
            </p>
          </section>
        </div>
        {/* <section className="flex flex-col gap-2">
          <h4 className="text-white font-bold text-[12px]">FOLLOW US</h4>
          <nav className="flex gap-2 h-fit">
            {socialLinks.map((link, index) => (
              <a key={index} href="#">
                <img
                  src={link.icon}
                  className="w-8 h-7"
                  alt={link.alt}
                />
              </a>
            ))}
          </nav>
        </section> */}
      </div>
      <div className="text-white text-xs tracking-wider border-t-2 border-white/15 pt-4 mt-13.5">
        © {isLolly ? 'Lolly Tech, Inc.' : 'OneHealth'} {new Date().getFullYear()}. All right reserved.
      </div>
    </footer>
  );
};
